import styles from '../Style/FeaturesComponents.module.scss';

type TableImage = {
  src: string;
  alt: string;
  imageSize?: {
    width: string;
    height: string;
  };
};

export type TableItem = {
  text: string;
  exampleText?: string;
  image?: TableImage | TableImage[];
  link?: {
    text: string;
    href: string;
  };
  type?: 'image' | 'link' | 'text' | 'file';
};

type TableProps = {
  th1: string;
  th2: string;
  tableObjects: TableItem[];
  theme?: 'light';
};

export function Table({ th1, th2, tableObjects, theme }: TableProps) {
  return (
    <table className={`${styles.table} ${theme ? styles.light : ''}`}>
      <thead>
        <tr>
          <th>{th1}</th>
          <th>{th2}</th>
        </tr>
      </thead>
      <tbody>
        {tableObjects.map((data, index) => {
          return (
            <tr key={`table-tr-${index}`}>
              <td>{data.text}</td>
              <td>
                {data.image && (
                  <div className={styles.imagesList}>
                    {(Array.isArray(data.image) ? data.image : [data.image]).map(
                      (image, imageIndex) => (
                        <a
                          key={`table-img-${index}-${imageIndex}`}
                          href={image.src}
                          target={'_blank'}
                          rel={'noreferrer'}
                        >
                          <div
                            style={{
                              width: image.imageSize != undefined ? image.imageSize.width : '300px',
                              height:
                                image.imageSize != undefined ? image.imageSize.height : 'unset',
                            }}
                            className={styles.imageContainer}
                          >
                            <img src={image.src} alt={image.alt} />
                          </div>
                        </a>
                      )
                    )}
                  </div>
                )}
                {data.link && (
                  <a href={data.link.href} download={data.type === 'file'}>
                    {data.link.text}
                  </a>
                )}
                {data.exampleText && <span>{data.exampleText}</span>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
